import type { ReactNode } from 'react';

export interface TemplateRowNoteProps {
  children: ReactNode;
}

/** A quiet fact beside a template's name: muted text, never a pill that reads as a button. */
export function TemplateRowNote({ children }: TemplateRowNoteProps) {
  return (
    <span data-slot='template-note' className='text-sm text-ink-muted'>
      {children}
    </span>
  );
}
